import type { Column } from 'react-table'

import Table from '~/components/atoms/Table/Table'
import Text, { TextSizes } from '~/components/atoms/Text/Text'

import { transformSanityTable } from './transformSanityTable'
import type { DynamicObjectType } from './types'

import styles from './TableBlock.module.css'

export interface TableBlockProps {
  testID?: string
  _key: string
  _type: string
  table: {
    rows: Array<{
      _key: string
      _type: string
      cells: string[]
    }>
  }
}

export default function TableBlock({ testID, ...tableData }: TableBlockProps) {
  const reactTableOptions = transformSanityTable(tableData)

  const [header, ...body] = reactTableOptions

  type DynamicTableType = DynamicObjectType<typeof header>

  const columns: Column<DynamicTableType>[] = Object.keys(header).map(
    headerItem => {
      return {
        Header: (
          <Text uppercase size={TextSizes.bodySml}>
            {header[headerItem]}
          </Text>
        ),
        accessor: headerItem,
        Cell: data => <Text size={TextSizes.bodySml}>{data.value}</Text>,
      }
    }
  )

  return (
    <div className={styles.base} data-testid={testID}>
      <Table<DynamicTableType>
        name={'genericTable'}
        columns={columns}
        data={body}
      />
    </div>
  )
}
